'use strict';
define(['app', 'components/st-keyword-trend/trend-bars'], function (app, buildTrendBars) {
    Controller.$inject = ['$filter', '$window'];

    function Controller($filter, $window) {
        var ctrl = this;
        ctrl.active = null;
        ctrl.activate = activate;
        ctrl.clearActive = clearActive;

        ctrl.$onChanges = function () {
            ctrl.trend = ctrl.bars || buildTrendBars({monthlySearchVolumes: ctrl.volumes || []});
            ctrl.trend.forEach(function (bar) {
                bar.valueLabel = bar.searches === null || bar.searches === undefined
                    ? '—'
                    : $filter('number')(bar.searches, 0);
            });
            ctrl.description = ctrl.trend.map(function (bar) {
                return bar.label + ': ' + bar.valueLabel;
            }).join(', ');
            ctrl.active = null;
        };

        function activate(bar, event) {
            ctrl.active = bar;
            var margin = 72;
            var x = event && typeof event.clientX === 'number'
                ? event.clientX
                : $window.innerWidth / 2;
            var y = event && typeof event.clientY === 'number' ? event.clientY : 0;
            ctrl.tooltipStyle = {
                left: Math.max(margin, Math.min($window.innerWidth - margin, x)) + 'px',
                top: (y - 10) + 'px'
            };
        }

        function clearActive() {
            ctrl.active = null;
        }
    }
    app.component('stKeywordTrend', {
        bindings: {volumes: '<', bars: '<?'},
        controller: Controller,
        templateUrl: 'app/components/st-keyword-trend/st-keyword-trend.html'
    });
});
